import { useI18n } from "../lib/i18n";
import { accountVerificationFrom } from "../lib/accountVerification";
import { ProfessionalBadges } from "./ProfessionalBadges";
import { Verified } from "./ui/kit";

/** [verification.public-signals](../../../docs/product/profiles-and-verification.md#verification-public-signals): one personal-name badge, with Professional approval replacing identity-only. */
export function AccountVerificationBadge({ identityVerified, verifiedProfessions = [] }: {
  identityVerified?: boolean;
  verifiedProfessions?: readonly string[];
}) {
  const { t } = useI18n();
  const verification = accountVerificationFrom({ identityVerified, verifiedProfessions });
  return verification.verifiedProfessions.length > 0
    ? <ProfessionalBadges professions={verification.verifiedProfessions} />
    : verification.identityVerified ? <Verified label={t("profile.identityVerified")} iconOnly /> : null;
}
